const viewAny = (permissions) => {
  return permissions.includes('access-vehicle-makes')
}

const create = (permissions) => {
  return hasPermission(permissions, 'access-vehicle-makes')
}

const update = (permissions) => {
  return hasPermission(permissions, 'access-vehicle-makes')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-vehicle-makes')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};